import React, { useContext } from 'react';
import { ResponsiveContext } from '../contexts/ResponsiveContext';
import { Link, useNavigate } from 'react-router-dom';
// import HomeImage from '../assets/img/home.png';
import HomeImage from '../assets/img/home.webp';
import LogoTienda from '../assets/img/logo-tienda.webp';

function Landing() {
  const { is1200, is1100 } = useContext(ResponsiveContext);
  const navigate = useNavigate();
  const handleShop = () => {
    navigate('/shop');
  };

  return (
    <div className='row'>
      <div
        className='col-12 col-md-12 col-lg-6'
        style={{
          height: '80vh',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            flex: '1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            height: '100%',
          }}
        >
          <div
            style={{
              height: '70vh',
              borderRadius: '30px',
              position: 'relative',
              overflow: 'hidden',
              boxShadow:
                'rgba(255, 120, 3, 0.4) 5px 5px, rgba(255, 120, 3, 0.3) 10px 10px, rgba(255, 120, 3, 0.2) 15px 15px, rgba(255, 120, 3, 0.1) 20px 20px, rgba(255, 120, 3, 0.05) 25px 25px',
            }}
          >
            <img
              src={HomeImage}
              alt=''
              style={{
                width: '100%',
                height: '100%',
                padding: '0',
                cursor: 'pointer',
              }}
              onClick={handleShop}
              className='col-12 m-0'
            />
          </div>
        </div>
      </div>

      <div className='col-12 col-md-12 col-lg-6 d-flex row justify-content-center'>
        <div className='d-flex row align-content-center justify-content-center'>
          <h6
            className={`${
              is1100 ? 'fs-2' : 'fs-4'
            } fw-bold text-muted fst-italic`}
            style={{
              boxShadow:
                'rgba(255, 120, 3, 0.4) 0px 5px, rgba(255, 120, 3, 0.3) 0px 10px, rgba(255, 120, 3, 0.2) 0px 15px, rgba(255, 120, 3, 0.1) 0px 20px, rgba(255, 120, 3, 0.05) 0px 25px',
              width: '80%',
              marginTop: '30px',
              marginBottom: '30px',
            }}
          >
            CONÓCENOS...
          </h6>
        </div>
        <div style={{ width: '80%' }}>
          <p
            className='fst-italic fw-bold my-4'
            style={{
              fontSize: `${is1200 ? '16px' : '14px'}`,
            }}
          >
            Somos una tienda especializada en el mundo del deporte, desde que
            abrimos nuestras puertas en el año 1973 en Madrid. Durante todo este
            tiempo hemos trabajado para ofrecer los mejores y más variados
            productos con una atención personalizada, basada en largos años de
            experiencia y con amplio conocimiento en el sector.
          </p>

          <p
            className='fst-italic fw-bold my-4'
            style={{
              fontSize: `${is1200 ? '16px' : '14px'}`,
            }}
          >
            Disponemos de material deportivo de primeras marcas a precios muy
            competitivos y durante todo el año.
          </p>
          <p
            className='fst-italic fw-bold my-4'
            style={{
              fontSize: `${is1200 ? '16px' : '14px'}`,
            }}
          >
            Trabajamos tanto moda textil, calzado,complementos y uniformes
            escolares.
          </p>

          <p
            className='fst-italic fw-bold my-4'
            style={{
              fontSize: `${is1200 ? '16px' : '14px'}`,
            }}
          >
            Muchos son los clientes que depositando su confianza en nosotros han
            hecho posible que llevemos 40 años abriendo nuestras puertas al
            público.
          </p>
        </div>
        <div className='navbar-brand d-flex justify-content-center align-items-start'>
          <Link
            className='navbar-brand d-flex justify-content-center'
            style={{ width: '80%' }}
            to='/shop'
          >
            <img
              alt='logo'
              src={LogoTienda}
              style={{ width: '40%', height: 'auto' }}
            />
            {/* <img
              alt='logo'
              src='/images/logo-tienda.png'
              style={{ width: '40%' }}
            /> */}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Landing;
